export default  {	
	data () {
		return { 
			filter: {
				mes_periodo: null,
				ano_periodo: null,
				id_datos_razon: null,
				servicios: [],
			}
		}
	},
	async created () { 
		this.filter.mes_periodo= this.gettersDatalist('list_mes',this.fecha().fecha.mesHoy)[0]
		this.filter.ano_periodo= this.gettersDatalist('list_ano',this.fecha().fecha.anoHoy)[0]
		this.filter.id_datos_razon= this.gettersDatalist('datos_razon',1)[0]
	},
	destroyed()
	{
		this.updateCrud({state: 'dataGet/archivo_retiros/data',data:[]})
	}
}
